<template>
  <el-row :gutter="10">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.profile"
        :primary-fields="[ 'name_full', 'email', 'phone_primary', 'position']"
        @sort="sort = $event"
        @apply="reload"
        @ready="load"
        @keyup.enter.native="$emit('apply')"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <UsersTable :users="users">
          <template
            v-if="canUpdate || canDelete"
            v-slot:actions="{ user }"
          >
            <el-dropdown
              :disabled="user.deleted"
              size="mini"
              split-button
              @command="handleActionCommand"
              @click="openViewForm(user)"
            >
              View
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :disabled="user.deleted"
                  icon="el-icon-edit"
                  :command="{ action: openForm, user}"
                >
                  Edit
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="!user.deleted"
                  type="danger"
                  icon="el-icon-delete"
                  :command="{ action: deleteUser, user}"
                >
                  Delete
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="user.deleted"
                  type="danger"
                  icon="el-icon-help"
                  :command="{ action: restoreUser, user}"
                >
                  Restore
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </UsersTable>
        <el-pagination
          class="text-center pt-3"
          :current-page.sync="users.page"
          :page-size.sync="users.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="users.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
      <el-dialog
        title="User's Profile"
        :visible.sync="isShow"
        :fullscreen="isFullScreen"
        width="60%"
        :close-on-click-modal="false"
        @opened="loadTimeZone(user)"
      >
        <UsersForm
          ref="userForm"
          :user="user"
        />
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="default"
            @click.native="isFullScreen =!isFullScreen "
          >
            <FontAwesomeIcon
              v-if="isFullScreen"
              :icon="['fal', 'compress']"
            />
            <FontAwesomeIcon
              v-else
              :icon="['fal', 'expand']"
            />
          </el-button>
          <el-button
            type="default"
            @click.native="isShow = false"
          >
            Cancel
          </el-button>
          <el-button
            type="primary"
            :loading="isSaving"
            @click.native="preSave"
          >
            {{ (user && user.id) ? 'Save' : 'Create' }}
          </el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="User Settings"
        :visible.sync="isShowView"
        :fullscreen="isFullScreen"
        :close-on-click-modal="false"
        width="60%"
      >
        <ViewForm
          ref="viewForm"
          :user="user"
          :fullscreen="isFullScreen"
        />
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="default"
            @click.native="isFullScreen =!isFullScreen "
          >
            <FontAwesomeIcon
              v-if="isFullScreen"
              :icon="['fal', 'compress']"
            />
            <FontAwesomeIcon
              v-else
              :icon="['fal', 'expand']"
            />
          </el-button>
          <el-button
            type="default"
            @click.native="isShowView = false"
          >
            Cancel
          </el-button>
        </span>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import UsersTable from '@/components/Application/Manage/Users/Table'
import UsersForm from '@/components/Application/Manage/Users/Form'
import ViewForm from '@/components/Application/Manage/Users/View.vue'
import { CREATE, UPDATE, DELETE } from '@/plugins/user'
import Vue from 'vue'
import BulkUserModal from '@/components/Application/Manage/Users/BulkModal.vue'

export default {
  components: {
    Filters,
    UsersTable,
    UsersForm,
    ViewForm
  },
  data () {
    return {
      bulkUserDialogInstance: null,
      bulkUserDialogVisible: false,
      isFullScreen: false,
      isLoading: true,
      isShow: false,
      isSaving: false,
      isShowView: false,
      users: [],
      filters: [],
      sort: {
        field: 'created_at',
        direction: 'asc'
      },
      user: null,
      alfred: [
        {
          name: 'Refresh Users',
          description: 'Reload the users list',
          keywords: ['users', 'refresh', 'list'],
          icon: ['fal', 'sync'],
          hidden: false,
          handler: () => {
            this.reload()
          }
        },
        {
          name: 'Bulk Create Users',
          description: 'Create multiple new users',
          keywords: ['users', 'bulk', 'create', 'new'],
          icon: ['fal', 'users'],
          hidden: false,
          handler: () => {
            this.showBulkUserModal()
          }
        },
        {
          name: 'Create User',
          description: 'Create a new user',
          keywords: ['users', 'create', 'new'],
          icon: ['fal', 'plus'],
          hidden: false,
          handler: () => {
            this.openForm(new this.$sdk.profile())
          }
        }
      ],
      actions: [
        [
          {
            hidden: this.$user.cannot(CREATE, this.$sdk.profile),
            name: 'Bulk Create',
            icon: ['fal', 'users'],
            event: this.showBulkUserModal
          }
        ],
        [
          {
            hidden: this.$user.cannot(CREATE, this.$sdk.profile),
            name: 'Create',
            icon: ['fal', 'plus'],
            event: () => {
              this.openForm(new this.$sdk.profile())
            }
          },
          {
            name: 'Refresh',
            icon: ['fal', 'sync'],
            event: this.reload
          }
        ]
      ]
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, this.$sdk.profile)
    },
    canDelete () {
      return this.$user.can(DELETE, this.$sdk.profile)
    }
  },
  methods: {
    showBulkUserModal () {
      const BulkUserModalClass = Vue.extend(BulkUserModal)

      this.bulkUserDialogInstance = new BulkUserModalClass({
        propsData: {
          dialogVisible: true
        }
      })

      this
        .bulkUserDialogInstance
        .$on('destroy', () => {
          this.bulkUserDialogVisible = false
        })

      this
        .bulkUserDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.bulkUserDialogInstance.$el)

      this.bulkUserDialogVisible = true
    },
    handleActionCommand ({ action, user }) {
      action(user)
    },
    load () {
      this.isLoading = true
      this.$sdk.profile.list(builder => {
        builder.filters = this.filters
        builder.include = 'teams,teams.account,sessions'
        builder.order = `${this.sort.field}:${this.sort.direction}`
      })
        .then(res => {
          this.users = res
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async reload () {
      this.isLoading = true
      try {
        await this.users.reload(builder => {
          builder.filters = this.filters
          builder.include = 'teams,teams.account,sessions'
          builder.order = `${this.sort.field}:${this.sort.direction}`
        })
      } catch {
        this.$message.error('Failed to refresh Users')
      }
      this.isLoading = false
    },
    restoreUser (user) {
      let name = user.name_full
      this.$confirm('Are you sure to restore this user?', 'Restore', {
        confirmButtonText: 'Restore',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        user.restore()
          .then(() => this.$message.success(`Successfully restored ${name}`))
          .catch(err => {
            this.$message.error(`An error occurred while restoring ${name}`)
            this.isLoading = false
            throw err
          })
          .finally(() => { this.reload() })
      })
    },
    deleteUser (user) {
      let name = user.name_full
      this.$confirm('Are you sure to delete this user?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        user.delete()
          .then(() => this.$message.success(`Successfully deleted ${name}`))
          .catch(err => {
            this.$message.error(`An error occurred while deleting ${name}`)
            this.isLoading = false
            throw err
          })
          .finally(() => { this.reload() })
      })
    },
    openForm (profile) {
      this.user = profile
      this.isShow = true
    },
    openViewForm (profile) {
      this.user = profile
      this.isShowView = true
    },
    preSave () {
      this.$refs['userForm'].validate(this.save)
    },
    save () {
      this.isSaving = true
      let name = this.user.name_full
      if (this.user.id) {
        this.user.email = this.user.email + ''

        this.user.update()
          .then(() => {
            this.$message.success(`Successfully update ${name}`)
            this.isSaving = false
            this.isShow = false
          })
          .catch(err => {
            this.$message.error(`An error occurred while updating ${name}`)
            this.isSaving = false
            throw err
          })
          .finally(() => { this.reload() })
      } else {
        this.user.create().then(() => {
          this.$message.success(`Successfully create record for ${name}`)
          this.isSaving = false
          this.isShow = false
        })
          .catch(err => {
            this.isSaving = false
            this.$message.error(`An error occurred while creating record ${name}`)
            throw err
          })
          .finally(() => { this.reload() })
      }
    },
    loadTimeZone (user) {
      if (user.time_zone) {
        this.$refs.userForm.searchTimeZone(user.time_zone.zone)
      }
    }
  }
}
</script>
